module.exports = __webpack_public_path__ + "static/img/抗疫物资.5ddf9a0b.jpg";